// import {} from '@/utils/compute-util.js'
// 订单金额计算
export const orderAmount = function() {
  const {
    preOrder,
    coupon,
    installment,
    // paymethod,
    openByStages,
    discountPricefroIntegral
  } = this
  let amount = preOrder.orderAmount // 剩余需要支付的订单
  console.log('openByStages', openByStages)
  // 计算优惠券
  const { installmentId } = installment
  console.log(installmentId, 'lll')
  const isFenqi = openByStages === 1 // 友邻分期不可使用优惠券
  const hasFenqi = isFenqi && installmentId !== 0
  console.log(hasFenqi)
  // 计算友邻分期
  if (hasFenqi) {
    amount = installment.downPayments || preOrder.orderAmount // 分期的首付
  }
  // 计算优惠券（分期可设置使用优惠券）
  if (coupon.id) {
    const discount = coupon.couponDiscount
    if (hasFenqi === false) {
      // 无分器
      amount = amount - discount
    } else {
      // 有分期
      amount = installment.downPayments // 分期的首付
    }
  }
  // 计算积分抵扣
  console.log('订单确认------', amount, discountPricefroIntegral)
  if (!isFenqi) {
    amount = amount - discountPricefroIntegral
  }
  // 格式化
  amount = parseFloat(amount || 0).toFixed(2)
  if (amount < 0) amount = 0
  return amount
}

// 订单金额计算,仅扣除优惠券
export const orderAmountNointegral = function() {
  const {
    preOrder,
    coupon,
    installment,
    // paymethod,
    openByStages
  } = this
  let amount = preOrder.orderAmount // 剩余需要支付的订单
  console.log('openByStages', openByStages)
  // 计算优惠券
  const { installmentId } = installment
  const isFenqi = openByStages === 1 // 友邻分期不可使用优惠券
  const hasFenqi = isFenqi && installmentId
  // 计算友邻分期
  if (hasFenqi) {
    amount = installment.downPayments // 分期的首付
  }

  // 计算优惠券（分期可设置使用优惠券）
  if (coupon.id) {
    const discount = coupon.couponDiscount
    if (hasFenqi === false) {
      // 无分器
      amount = amount - discount
    } else {
      // 有分期
      amount = installment.downPayments // 分期的首付
    }
  }
  // 格式化
  amount = parseFloat(amount || 0).toFixed(2)
  if (amount < 0) amount = 0
  return amount
}

// 订单金额计算（真正支付的，扣优惠券+积分）
export const orderAmountReal = function() {
  const {
    preOrder,
    coupon,
    installment,
    discountPricefroIntegral
    // paymethod
  } = this
  let amount = preOrder.orderAmount
  console.log(amount, ';;;;')
  // const { useCoupon } = installment
  // const isFenqi = paymethod === 2 // 友邻分期不可使用优惠券
  const isFenqi = false // 友邻分期不可使用优惠券 //更改可使用

  // 计算优惠券
  if (!isFenqi && coupon.id) {
    const { couponDiscount: discount } = coupon
    amount = amount - discount
  }
  // 计算积分抵扣
  if (!isFenqi) {
    amount = amount - (discountPricefroIntegral || 0)
  }
  // 格式化
  amount = parseFloat(amount || 0).toFixed(2)
  if (amount < 0) amount = 0
  return amount
}
